import { render } from "./ChangePasswordFirstAccess.vue?vue&type=template&id=44dc1707&scoped=true"
import script from "./ChangePasswordFirstAccess.vue?vue&type=script&lang=js"
export * from "./ChangePasswordFirstAccess.vue?vue&type=script&lang=js"

import "./ChangePasswordFirstAccess.vue?vue&type=style&index=0&id=44dc1707&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dc1707"]])

export default __exports__